import { Area } from '@/shared/model/enumerations/area';
import { EntidadLegajo, EstadoItemLegajo, EventoLegajo } from '@/shared/model/legajo/legajo.constant';

export interface IFiltroLegajo {
  area?: Area;
  entidadLegajo?: EntidadLegajo;
  entidadesLegajo?: Array<EntidadLegajo>;
  eventoLegajo?: EventoLegajo;
  eventosLegajo?: Array<EventoLegajo>;
  solucionId?: string;
  solicitudId?: string;
  participacionId?: string;
  tag?: string;
  fechaInicio?: Date;
  fechaFin?: Date;
}

export class FiltroLegajo implements IFiltroLegajo {
  constructor(
    public area?: Area,
    public entidadLegajo?: EntidadLegajo,
    public entidadesLegajo?: Array<EntidadLegajo>,
    public eventoLegajo?: EventoLegajo,
    public eventosLegajo?: Array<EventoLegajo>,
    public solucionId?: string,
    public solicitudId?: string,
    public participacionId?: string,
    public tag?: string,
    public fechaInicio?: Date,
    public fechaFin?: Date
  ) {}

  static fromObject(item: IFiltroLegajo): FiltroLegajo {
    const legajo = new FiltroLegajo();

    for (const [key, value] of Object.entries(item)) {
      legajo[key] = value;
    }

    return legajo;
  }
}

export interface ILegajoItem {
  campo?: string;
  valorAnterior?: string;
  valorNuevo?: string;
  visible?: string;
  estado?: EstadoItemLegajo;
  datos?: object;
}

export class LegajoItem implements ILegajoItem {
  constructor(
    public campo?: string,
    public valorAnterior?: string,
    public valorNuevo?: string,
    public visible?: string,
    public estado?: EstadoItemLegajo,
    public datos?: object
  ) {}

  static fromObject(item: ILegajoItem): LegajoItem {
    const legajoItem = new LegajoItem();

    for (const [key, value] of Object.entries(item)) {
      legajoItem[key] = value;
    }

    return legajoItem;
  }
}

export interface ILegajo {
  id?: string;
  area?: Area;
  entidadLegajo?: EntidadLegajo;
  eventoLegajo?: EventoLegajo;
  solucionId?: string;
  solicitudId?: string;
  participacionId?: string;
  items?: Array<LegajoItem>;
  nombreCompletoBy?: string;
  datos?: object;
  createdBy?: string;
  createdDate?: Date;
  lastModifiedBy?: string;
  lastModifiedDate?: Date;
}

export class Legajo implements ILegajo {
  constructor(
    public id?: string,
    public area?: Area,
    public entidadLegajo?: EntidadLegajo,
    public eventoLegajo?: EventoLegajo,
    public solucionId?: string,
    public solicitudId?: string,
    public participacionId?: string,
    public items?: Array<LegajoItem>,
    public nombreCompletoBy?: string,
    public datos?: object,
    public createdBy?: string,
    public createdDate?: Date,
    public lastModifiedBy?: string,
    public lastModifiedDate?: Date
  ) {}

  static fromObject(item: ILegajo): Legajo {
    const legajo = new Legajo();

    for (const [key, value] of Object.entries(item)) {
      legajo[key] = value;
    }

    return legajo;
  }
}

/**
 * Clases de menús auxiliares
 */
export interface IMenuEntidadLegajo {
  text: string;
  value?: EntidadLegajo;
}

export class MenuEntidadLegajo implements IMenuEntidadLegajo {
  constructor(public text: string, public value?: EntidadLegajo) {}
}

export interface IMenuEventoLegajo {
  text: string;
  value?: EventoLegajo;
}

export class MenuEventoLegajo implements IMenuEventoLegajo {
  constructor(public text: string, public value?: EventoLegajo) {}
}

export interface IDatoLegajo {
  text: string;
  value?: string;
}

export class DatoLegajo implements IDatoLegajo {
  constructor(public text: string, public value?: string) {}
}
